import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PageTemplateTable } from '../../../../directives/page-template-table/page-template-table';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { StoreManagerService } from '../../../../services/api-store/store-manager/store-manager.service';
import { StoreService } from '../../../../services/api-store/store/store.service';
import { StoreRequestSearch } from '../../../../models/api-store/store/store.request.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contattistoremanager',
  templateUrl: './contattistoremanager.component.html',
  styleUrls: ['./contattistoremanager.component.css']
})
export class ContattistoremanagerComponent extends PageTemplateTable implements OnInit, OnDestroy, AfterViewInit {

  searchFilterForm: FormGroup;
  searchFilterOther = {}
  public isEmpty: boolean = false;
  public isSearching: boolean = false;

  
  constructor(
    private router: Router,
    private storeManagerService:StoreManagerService,
    private storeService:StoreService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public modalService: NgbModal
  ) {
    super(modalService);
    this.searchFilterForm = this.fb.group({
      searchOldValue:'',
      searchFilterField: ''
    });
   }
/**
   * Inizializza la tabella
   */
 initTable() {
  const that = this;
  this.initCommon_dtOptions();
  this.dtOptions['columnDefs'] = [
    {orderable: false,targets: 0,width:'5%'},
    {orderable: false,targets: 1,width:'20%'},
    {orderable: false,targets: 2,width:'15%'},
    {orderable: false,targets: 3,width:'15%'},
    {orderable: false,targets: 4,width:'10%'},
    {orderable: false,targets: 5,width:'10%'},
    {orderable: false,targets: 6,width:'10%'},
    {orderable: false,targets: 7,width:'15%'},
    {orderable: false,targets: 8,width:'5%'}
  ];
  this.dtOptions['ajax'] = (dataTablesParameters: any, callback) => {
    this.isSearching = true;
    
    if (dataTablesParameters.start > 0) {
      dataTablesParameters.start = dataTablesParameters.start / this.dimPagina;
    }
    that.numeroPagina = dataTablesParameters.start;
    that.dimPagina  = dataTablesParameters.length;
    let requestSearch = that.getFilter();
    that.storeService.search(requestSearch).subscribe(
      (response) => {
        
        if(response){
          if (response.data.length == 0) {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
          that.setListEntityList(response);
          callback({
            recordsTotal: response.total,
            recordsFiltered: response.total,
            data: []
          });
        }else{
          this.isEmpty = false;
          callback({
            recordsTotal: 0,
            recordsFiltered: 0,
            data: []
          });
        }
        
        that.spinner.hide();
        that.isSearching = false;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        that.spinner.hide();
        that.isSearching = false;
      }
    );
  }
}

ngOnInit() {
  
  this.initTable();
}

ngAfterViewInit() {
  this.dtTrigger.next();
}

ngOnDestroy(): void {
  this.dtTrigger.unsubscribe();
}

/**
 * Click sulla lente per la ricerca
 */
 clickSearch() {
  this.searchFilterForm.controls.searchOldValue.setValue(this.searchFilterForm.controls.searchFilterField.value);
  this.resetFilter();
  this.ajaxReload();
}

changeFilter(){
  this.searchFilterForm.controls.searchFilterField.setValue(this.searchFilterForm.controls.searchOldValue.value);
  this.resetFilter();
  this.ajaxReload();
}


 /**
 * Prende i filtri
 * @returns 
 */
  getFilter() {
    let request = new StoreRequestSearch();
    request.embeddedManager = this.searchFilterForm.controls['searchFilterField'].value;
    request.pageNumber = this.numeroPagina;
    request.pageSize = this.dimPagina;
    return request;
  }


  clickButtonUpdate(id){
    const url = 'store/store/' + id;
    this.router.navigate([url], { 
      fragment : 'storemanager',
      queryParams: { history: true }, 
      queryParamsHandling: 'preserve' });
  }

  
  clickButtonClearFilter(){
    this.searchFilterForm.controls.searchFilterField.setValue('');
    this.clickSearch();
  }

}
